<header
  #scrollContainer
  [ngClass]="{
    'bg-[var(--blue)] absolute': !scrolled,
    'sticky bg-white': scrolled
  }"
  class="top-0 w-full z-50 mx-auto">
  <div class="max-w-7xl flex items-center justify-between px-3 mx-auto">
    <!-- Left: Logo -->
    <div class="flex items-center space-x-6">
      <img
        *ngIf="!scrolled"
        src="./assets/images/brand/orbit-final-logo.webp"
        alt="Orbit Logo"
        loading="lazy"
        (click)="goTo('/')"
        class="h-12 sm:h-16 lg:h-20 w-auto cursor-pointer" />
      <img
        *ngIf="scrolled"
        src="./assets/images/brand/orbit-dark-logo.webp"
        alt="Orbit Logo"
        loading="lazy"
        (click)="goTo('/')"
        class="h-12 sm:h-16 lg:h-20 w-auto cursor-pointer" />

      <div *ngIf="scrolled" class="w-full hidden lg:block">
        <div
          class="text-[#2D2D2D]"
          class="max-w-7xl px-8 flex items-center gap-x-3 px-6 py-4 mx-auto">
          <img src="assets/images/home.png" loading="lazy" class="filter invert" />
          <img src="assets/images/arrow.png" loading="lazy" class="filter invert" />
          <span class="">Products</span>
          <img src="assets/images/arrow.png" loading="lazy" class="filter invert" />
          <span class="whitespace-nowrap">ORBIT</span>
        </div>
      </div>

      <a
        *ngIf="!scrolled"
        href="#"
        class="text-white hover:underline font-medium hidden lg:hidden">
        Products
      </a>
      <a
        *ngIf="!scrolled"
        href="#"
        class="text-white hover:underline font-medium hidden lg:hidden">
        Services
      </a>
      <a
        *ngIf="!scrolled"
        href="#"
        class="text-white hover:underline font-medium hidden lg:hidden">
        Careers
      </a>
      <a
        *ngIf="!scrolled"
        href="#"
        class="text-white hover:underline font-medium hidden lg:hidden">
        Partner & Profit
      </a>
    </div>

    <!-- Right Section -->
    <div class="flex space-x-6 items-center">
      <a
        *ngIf="!scrolled"
        [routerLink]="['/auth/login']"
        class="border border-white text-white px-10 py-4 text-sm font-bold rounded-md hover:bg-indigo-900 transition hidden lg:block">
        Login
      </a>
      <a
        *ngIf="!scrolled"
        [routerLink]="['/auth/register']"
        class="border border-white text-white px-10 py-4 text-sm font-bold rounded-md hover:bg-indigo-900 transition hidden lg:block">
        Register
      </a>

      <!-- Mobile menu button -->
      <button
        class="focus:outline-none flex md:hidden rounded"
        [ngClass]="{
          'flex md:hidden': !scrolled,
          'flex md:flex': scrolled
        }"
        (click)="isMenuOpen = !isMenuOpen">
        <img
          *ngIf="!scrolled"
          src="./assets/images/hamburger-white.png"
          loading="lazy"
          alt="Menu"
          class="w-8 h-8 lg:w-10 lg:h-10" />
        <img
          *ngIf="scrolled"
          src="./assets/images/hamburger-blue.png"
          loading="lazy"
          alt="Menu"
          class="w-8 h-8 lg:w-10 lg:h-10" />
      </button>
    </div>
  </div>

  <!-- Mobile dropdown -->
  <div *ngIf="isMenuOpen" class="fixed inset-0 flex justify-end z-50">
    <!-- Backdrop -->
    <div
      class="absolute inset-0 bg-black/50 backdrop-blur-sm"
      (click)="isMenuOpen = false"></div>

    <!-- Sliding Menu -->
    <div
      class="relative w-64 h-full transform transition-transform duration-500 ease-in-out"
      [ngClass]="{
        'translate-x-0': isMenuOpen,
        'translate-x-full': !isMenuOpen
      }"
      style="
        background: linear-gradient(
          180deg,
          #2d7cfd 0%,
          #2d7cfd 39.94%,
          #4fa5f4 113.79%
        );
      ">
      <div
        style="
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.58) 0%,
            rgba(0, 0, 0, 0) 100%
          );
        "
        class="p-6 space-y-4">
        <a href="#" class="block text-white hover:underline font-medium">
          Products
        </a>
        <a href="#" class="block text-white hover:underline font-medium">
          Services
        </a>
        <a href="#" class="block text-white hover:underline font-medium">
          Careers
        </a>
        <a href="#" class="block text-white hover:underline font-medium">
          Partner & Profit
        </a>
        <a
          [routerLink]="['/auth/login']"
          class="block text-white hover:underline font-medium">
          Login
        </a>
        <a
          [routerLink]="['/auth/register']"
          class="block text-white hover:underline font-medium">
          Register
        </a>
      </div>
    </div>
  </div>
</header>
